document.addEventListener('DOMContentLoaded', function () {
  /* Global */
  initialize_mega_menu();
  initialize_visitor_tracking();
  /* Home Page */
  initialize_supplier_slider();
  /* Collections Pages */
  update_collection_tags();
  /* Contact Page */
  initialize_sandblast_map();

  const selector = document.getElementById('size-selector');
  if (!selector) return;

  const currentUrlSlug = window.location.pathname
    .split('/')
    .filter(Boolean)
    .pop()
    .toLowerCase();

  const normalize = (str) => {
    return str
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')         
      .replace(/[^a-z0-9\-]/g, ''); 
  };

  /*const buttons = selector.querySelectorAll('.variant-button');

  buttons.forEach(label => {
    const input = label.querySelector('input');
    const textLink = label.querySelector('span a');

    if (input && textLink) {
      const normalizedText = normalize(textLink.textContent);

      if (normalizedText === currentUrlSlug) {
        input.checked = true;

        
        const matchedVariantId = input.value;
        const variantTargetInput = document.querySelector('input.product-variant-id');
        if (variantTargetInput) {
          variantTargetInput.value = matchedVariantId;
        }
      }
    }
  });*/

  var productTitle = window.currentProductTitle;
  if (!productTitle) return;

  var variantSpans = document.querySelectorAll('#size-selector.variant-buttons .variant-button span');

  for (var i = 0; i < variantSpans.length; i++) {
    var span = variantSpans[i];
    if (span.textContent.trim() === productTitle.trim()) {
      var parentButton = span.closest('.variant-button');
      if (parentButton) {
        parentButton.classList.add('checked');
      }
    }
  }
  
});

/**
 * Initializes and manages the mega menu functionality.
 * @function
 */
const initialize_mega_menu = () => {
  const mega_menu_items = document.querySelectorAll('.mega-menu-item');
  let active_mega_menu = null;
  let hover_timeout = null;

  /**
   * Displays the specified mega menu content.
   * @param {HTMLElement} menu_content - The content element of the mega menu to show.
   */
  const show_mega_menu = (menu_content) => {
    if (!menu_content) return;
    if (active_mega_menu && active_mega_menu !== menu_content) {
      hide_mega_menu(active_mega_menu);
    }
    menu_content.classList.remove('opacity-0', 'pointer-events-none');
    active_mega_menu = menu_content;
  };

  /**
   * Hides the specified mega menu content.
   * @param {HTMLElement} menu_content - The content element of the mega menu to hide.
   */
  const hide_mega_menu = (menu_content) => {
    if (!menu_content) return;
    menu_content.classList.add('opacity-0', 'pointer-events-none');
    if (active_mega_menu === menu_content) {
      active_mega_menu = null;
    }
  };

  /**
   * Handles the mouse enter event for a mega menu item.
   * @param {HTMLElement} content - The content element of the mega menu.
   */
  const handle_menu_item_mouse_enter = (content) => {
    clearTimeout(hover_timeout);
    if (active_mega_menu && active_mega_menu !== content) {
      hide_mega_menu(active_mega_menu);
    }
    if (content) {
      show_mega_menu(content);
    }
  };

  /**
   * Handles the mouse leave event for a mega menu content.
   * @param {HTMLElement} content - The content element of the mega menu.
   */
  const handle_content_mouse_leave = (content) => {
    hover_timeout = setTimeout(() => {
      hide_mega_menu(content);
    }, 100); // Small delay to prevent flickering
  };

  /**
   * Handles the click event for a mega menu trigger.
   * @param {Event} event - The click event.
   * @param {HTMLElement} content - The content element of the mega menu.
   */
  const handle_trigger_click = (event, content) => {
    event.stopPropagation();
    if (content) {
      if (content.classList.contains('opacity-0')) {
        show_mega_menu(content);
      } else {
        hide_mega_menu(content);
      }
    }
  };

  mega_menu_items.forEach((item) => {
    const trigger = item.querySelector('.mega-menu-trigger');
    const content = item.querySelector('.mega-menu-content');

    item.addEventListener('mouseenter', () =>
      handle_menu_item_mouse_enter(content),
    );

    if (content) {
      content.addEventListener('mouseleave', () =>
        handle_content_mouse_leave(content),
      );
      content.addEventListener('mouseenter', () => clearTimeout(hover_timeout));
      content.addEventListener('click', (e) => e.stopPropagation());
    }

    if (trigger) {
      trigger.addEventListener('click', (e) =>
        handle_trigger_click(e, content),
      );
    }
  });

  // Close the mega menu when clicking outside
  document.addEventListener('click', () => {
    if (active_mega_menu) {
      hide_mega_menu(active_mega_menu);
    }
  });
};

/**
 * Updates the text content of elements with the class 'collection-tag' based on the current URL.
 * This function handles the entire process of extracting the URL segment, formatting the text,
 * and updating the tag elements.
 * @function
 */
const update_collection_tags = () => {
  const current_url = window.location.pathname;
  const collection_tags = document.querySelectorAll('.collection-tag');

  if (collection_tags.length === 0) return;

  const segments = current_url.split('/').filter((segment) => segment !== '');
  const last_segment =
    segments.length > 0 ? segments[segments.length - 1] : null;

  if (!last_segment) return;

  const formatted_text = last_segment
    .replace(/-/g, ' ')
    .replace(/&/g, '&')
    .replace(/®/g, ' ')
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
    .replace('%c2%ae', ' ');

  collection_tags.forEach((tag) => {
    try {
      tag.textContent = formatted_text;
    } catch (tag_error) {
      console.error('Error al actualizar un tag específico:', tag_error);
    }
  });
};

/**
 * Initializes and configures the Sandblast Solutions map for the contact page.
 * @function
 */
const initialize_sandblast_map = () => {
  const map_element = document.getElementById('map');
  if (!map_element) return;
  const map = create_map();
  const custom_icon = create_custom_icon();
  const markers_data = get_markers_data();

  add_markers_to_map(map, custom_icon, markers_data);
  adjust_map_for_mobile(map);

  /* Functions */
  function create_map() {
    const map = L.map('map', {
      center: [40.5, -77.5],
      zoom: 7,
      zoomControl: false,
      attributionControl: false,
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
    }).addTo(map);

    map.getContainer().style.filter = 'grayscale(100%) brightness(90%)';

    return map;
  }

  function create_custom_icon() {
    return L.icon({
      iconUrl:
        'https://cdn.shopify.com/s/files/1/0700/4058/4480/files/Pin.png',
      iconSize: [117, 62],
      iconAnchor: [115, 35],
      popupAnchor: [0, -35],
    });
  }

  function get_markers_data() {
    return [
      {
        position: [40.9943167, -80.6571677],
        title: 'Sandblast Solutions, Inc. (Ohio)',
        google_maps_url:
          'https://www.google.com.mx/maps/search/+201+McClurg+Road,+Youngstown,+OH+044512/@40.9943167,-80.6571677,18.21z?entry=ttu&g_ep=EgoyMDI1MDEyNi4wIKXMDSoASAFQAw%3D%3D',
      },
      {
        position: [40.254946137314114, -74.43951461216581],
        title: 'Sandblast Solutions, Inc. (New Jersey)',
        google_maps_url:
          'https://www.google.com/maps/place/Sandblast+Solutions,+Inc./@40.0766129,-74.8117735,17z/data=!3m1!4b1!4m6!3m5!1s0x89c3d84fb86dafb9:0xf08b263eaaeae382!8m2!3d40.0766129!4d-74.8117735!16s%2Fg%2F11c1z0_0hy',
      },
    ];
  }

  function add_markers_to_map(map, custom_icon, markers_data) {
    markers_data.forEach((marker_info) => {
      L.marker(marker_info.position, { icon: custom_icon }).addTo(map)
        .bindPopup(`
          <div>
            <h3>${marker_info.title}</h3>
            <a href="${marker_info.google_maps_url}" target="_blank" rel="noopener noreferrer">Open in Google Maps</a>
          </div>
        `);
    });
  }

  function adjust_map_for_mobile(map) {
    function update_map_view() {
      const width = window.innerWidth;
      if (width <= 768) {
        map.setZoom(6);
        map.panTo([40.5, -78.5]);
      } else {
        map.setZoom(7);
        map.panTo([40, -77.5]);
      }
    }

    update_map_view();
    window.addEventListener('resize', update_map_view);
  }
};

/**
 * Initializes and sets up the supplier slider functionality.
 * This function encapsulates all the slider-related code.
 */
const initialize_supplier_slider = () => {
  const track = document.querySelector('.supplier-track');
  if (!track) return;

  const slides = track.querySelectorAll('.supplier-slide');
  if (slides.length === 0) return;

  set_animation_duration(track, slides);
  add_hover_listeners(track);

  /**
   * Sets the animation duration for the supplier track based on the number of slides.
   * @param {HTMLElement} track - The track element containing the slides.
   * @param {NodeList} slides - The collection of slide elements.
   */
  function set_animation_duration(track, slides) {
    const seconds_per_slide = 2;
    const animation_duration = slides.length * seconds_per_slide;
    track.style.animationDuration = `${animation_duration}s`;
  }

  /**
   * Adds mouseenter and mouseleave event listeners to the track for pausing and resuming animation.
   * @param {HTMLElement} track - The track element to add listeners to.
   */
  function add_hover_listeners(track) {
    track.addEventListener('mouseenter', () => {
      track.style.animationPlayState = 'paused';
    });
    track.addEventListener('mouseleave', () => {
      track.style.animationPlayState = 'running';
    });
  }
};

/**
 * Initializes and manages the visitor source tracking and form display functionality.
 * This includes tracking the visitor source and showing the appropriate contact form.
 * @function
 */
const initialize_visitor_tracking = () => {
  const STORAGE_KEY = 'visitorSource';
  const EXPIRATION_DAYS = 5;

  // Configuration object for form pairs
  const FORM_PAIRS = [
    {
      regular: 'regular-contact-form',
      ads: 'ads-contact-form',
    },
    {
      regular: 'regular-catalog-form',
      ads: 'ads-catalog-form',
    },
    {
      regular: 'regular-quotes-form',
      ads: 'ads-quotes-form',
    },
    // Add more form pairs as needed:
    // {
    //   regular: 'regular-quote-form',
    //   ads: 'ads-quote-form'
    // }
  ];

  // Initialize tracking on load
  const stored_source = get_stored_source();
  if (!stored_source) {
    const current_source = get_referral_source();
    save_source(current_source);
  }

  // Initialize form visibility if forms are present
  //initialize_form_visibility();

  /**
   * Gets the current visitor's source information by analyzing URL parameters and referrer.
   * @returns {Object} Source information including type and details
   */
  function get_referral_source() {
    const urlParams = new URLSearchParams(window.location.search);
    const utmSource = urlParams.get('utm_source');
    const utmMedium = urlParams.get('utm_medium');
    const utmCampaign = urlParams.get('utm_campaign');
    const gclid = urlParams.get('gclid');
    const referrer = document.referrer;

    let source = {
      type: 'direct',
      details: {},
      timestamp: new Date().getTime(),
      expirationDate: new Date(
        new Date().getTime() + EXPIRATION_DAYS * 24 * 60 * 60 * 1000,
      ),
    };

    if (gclid) {
      source.type = 'google_ads';
      source.details = {
        gclid: gclid,
        referrer: referrer,
      };
    } else if (utmSource === 'google' && utmMedium === 'cpc') {
      source.type = 'google_ads';
      source.details = {
        campaign: utmCampaign,
        keyword: urlParams.get('utm_term'),
        content: urlParams.get('utm_content'),
      };
    } else if (referrer.includes('google.com') && !utmSource) {
      source.type = 'google_organic';
      source.details = {
        referrer: referrer,
      };
    } else if (referrer) {
      source.type = 'referral';
      source.details = {
        site: new URL(referrer).hostname,
        fullUrl: referrer,
      };
    }

    return source;
  }

  /**
   * Saves the source information to localStorage.
   * @param {Object} source - The source information to save
   */
  function save_source(source) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(source));
    } catch (error) {
      console.error('Error saving source:', error);
    }
  }

  /**
   * Retrieves the stored source information from localStorage.
   * @returns {Object|null} The stored source information or null if not found/expired
   */
  function get_stored_source() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) return null;

      const source = JSON.parse(stored);
      if (new Date(source.expirationDate) < new Date()) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }

      return source;
    } catch (error) {
      console.error('Error getting stored source:', error);
      return null;
    }
  }

  /**
   * Updates the visibility of a form pair based on the visitor source.
   * @param {string} regular_form_id - The ID of the regular form
   * @param {string} ads_form_id - The ID of the ads form
   * @param {Object|null} source - The visitor source data
   */
  /*function update_form_pair_visibility(regular_form_id, ads_form_id, source) {
    const regular_form = document.getElementById(regular_form_id);
    const ads_form = document.getElementById(ads_form_id);

    if (!regular_form || !ads_form) return;

    if (source && source.type === 'google_ads') {
      ads_form.style.display = 'block';
      regular_form.style.display = 'none';
    } else {
      ads_form.style.display = 'none';
      regular_form.style.display = 'block';
    }
  }*/

  /**
   * Initializes the visibility for all configured form pairs based on the stored source.
   */
  /*function initialize_form_visibility() {
    const source = get_stored_source();
    FORM_PAIRS.forEach((pair) => {
      update_form_pair_visibility(pair.regular, pair.ads, source);
    });
  }*/
};

var OpenableElement = class extends CustomHTMLElement {
    static get observedAttributes() {
      return ['open'];
    }
    constructor() {
      super();
      if (Shopify.designMode) {
        this.rootDelegate.on('shopify:section:select', (event) =>
          filterShopifyEvent(event, this, () => (this.open = true))
        );
        this.rootDelegate.on('shopify:section:deselect', (event) =>
          filterShopifyEvent(event, this, () => (this.open = false))
        );
      }
      if (this.hasAttribute('append-body')) {
        const existingNode = document.getElementById(this.id);
        this.removeAttribute('append-body');
        if (existingNode && existingNode !== this) {
          existingNode.replaceWith(this.cloneNode(true));
          this.remove();
        } else {
          document.body.appendChild(this);
        }
      }
    }
    connectedCallback() {
      this.delegate.on(
        'click',
        '.openable__overlay',
        () => (this.open = false)
      );
      this.delegate.on('click', '[data-action="close"]', (event) => {
        event.stopPropagation();
        this.open = false;
      });
    }
    get requiresLoading() {
      return this.hasAttribute('href');
    }
    get open() {
      return this.hasAttribute('open');
    }
    set open(value) {
      if (value) {
        (async () => {
          await this._load();
          this.clientWidth;
          this.setAttribute('open', '');
        })();
      } else {
        this.removeAttribute('open');
      }
    }
    get shouldTrapFocus() {
      return true;
    }
    get returnFocusOnDeactivate() {
      return (
        !this.hasAttribute('return-focus') ||
        this.getAttribute('return-focus') === 'true'
      );
    }
    get focusTrap() {
      return (this._focusTrap =
        this._focusTrap ||
        createFocusTrap(this, {
          fallbackFocus: this,
          initialFocus: this.hasAttribute('initial-focus-selector')
            ? this.getAttribute('initial-focus-selector')
            : void 0,
          clickOutsideDeactivates: (event) =>
            !(
              event.target.hasAttribute('aria-controls') &&
              event.target.getAttribute('aria-controls') === this.id
            ),
          allowOutsideClick: (event) =>
            event.target.hasAttribute('aria-controls') &&
            event.target.getAttribute('aria-controls') === this.id,
          returnFocusOnDeactivate: this.returnFocusOnDeactivate,
          onDeactivate: () => (this.open = false),
          preventScroll: true,
        }));
    }
    attributeChangedCallback(name, oldValue, newValue) {
      switch (name) {
        case 'open':
          if (oldValue === null && newValue === '') {
            if (this.shouldTrapFocus) {
              setTimeout(() => this.focusTrap.activate(), 150);
            }
            triggerEvent(this, 'openable-element:open');
          } else if (newValue === null) {
            if (this.shouldTrapFocus) {
              this.focusTrap.deactivate();
            }
            triggerEvent(this, 'openable-element:close');
          }
      }
    }
    async _load() {
      if (!this.requiresLoading) {
        return;
      }
      triggerNonBubblingEvent(this, 'openable-element:load:start');
      const response = await fetch(this.getAttribute('href'));
      const element = document.createElement('div');
      element.innerHTML = await response.text();
      this.innerHTML = element.querySelector(
        this.tagName.toLowerCase()
      ).innerHTML;
      this.removeAttribute('href');
      triggerNonBubblingEvent(this, 'openable-element:load:end');
    }
  };
  window.customElements.define('openable-element', OpenableElement);

var PhotoSwipeUi = class {
    constructor(pswp) {
      this.photoSwipeInstance = pswp;
      this.delegate = new main_default(this.photoSwipeInstance.scrollWrap);
      this.maxSpreadZoom = window.themeVariables.settings.mobileZoomFactor || 2;
      this.pswpUi =
        this.photoSwipeInstance.scrollWrap.querySelector('.pswp__ui');
      this.delegate.on(
        'click',
        '[data-action="pswp-close"]',
        this._close.bind(this)
      );
      this.delegate.on(
        'click',
        '[data-action="pswp-prev"]',
        this._goToPrev.bind(this)
      );
      this.delegate.on(
        'click',
        '[data-action="pswp-next"]',
        this._goToNext.bind(this)
      );
      this.delegate.on(
        'click',
        '[data-action="pswp-move-to"]',
        this._moveTo.bind(this)
      );
      this.photoSwipeInstance.listen('close', this._onPswpClosed.bind(this));
      this.photoSwipeInstance.listen(
        'doubleTap',
        this._onPswpDoubleTap.bind(this)
      );
      this.photoSwipeInstance.listen(
        'beforeChange',
        this._onPswpBeforeChange.bind(this)
      );
      this.photoSwipeInstance.listen(
        'initialZoomInEnd',
        this._onPswpInitialZoomInEnd.bind(this)
      );
      this.photoSwipeInstance.listen(
        'initialZoomOut',
        this._onPswpInitialZoomOut.bind(this)
      );
      this.photoSwipeInstance.listen(
        'parseVerticalMargin',
        this._onPswpParseVerticalMargin.bind(this)
      );
      this.delegate.on('pswpTap', '.pswp__img', this._onPswpTap.bind(this));
    }
    init() {
      const prevNextButtons = this.pswpUi.querySelector(
          '.pswp__prev-next-buttons'
        ),
        dotsNavWrapper = this.pswpUi.querySelector('.pswp__dots-nav-wrapper');
      if (this.photoSwipeInstance.items.length <= 1) {
        prevNextButtons.style.display = 'none';
        dotsNavWrapper.style.display = 'none';
        return;
      }
      prevNextButtons.style.display = '';
      dotsNavWrapper.style.display = '';
      let dotsNavHtml = '';
      this.photoSwipeInstance.items.forEach((item, index) => {
        dotsNavHtml += `
        <button class="dots-nav__item tap-area" ${
          index === 0 ? 'aria-current="true"' : ''
        } data-action="pswp-move-to">
          <span class="visually-hidden">Go to slide ${index}</span>
        </button>
      `;
      });
      dotsNavWrapper.querySelector(
        '.pswp__dots-nav-wrapper .dots-nav'
      ).innerHTML = dotsNavHtml;
    }
    _close() {
      this.photoSwipeInstance.close();
    }
    _goToPrev() {
      this.photoSwipeInstance.prev();
    }
    _goToNext() {
      this.photoSwipeInstance.next();
    }
    _moveTo(event, target) {
      this.photoSwipeInstance.goTo(
        [...target.parentNode.children].indexOf(target)
      );
    }
    _onPswpClosed() {
      this.delegate.off('pswpTap');
    }
    _onPswpDoubleTap(point) {
      const initialZoomLevel =
        this.photoSwipeInstance.currItem.initialZoomLevel;
      if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
        this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
      } else {
        this.photoSwipeInstance.zoomTo(
          initialZoomLevel < 0.7 ? 1 : this.maxSpreadZoom,
          point,
          333
        );
      }
    }
    _onPswpTap(event) {
      if (event.detail.pointerType === 'mouse') {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    }
    _onPswpBeforeChange() {
      if (this.photoSwipeInstance.items.length <= 1) {
        return;
      }
      const activeDot = this.photoSwipeInstance.scrollWrap.querySelector(
        `.dots-nav__item:nth-child(${
          this.photoSwipeInstance.getCurrentIndex() + 1
        })`
      );
      activeDot.setAttribute('aria-current', 'true');
      getSiblings(activeDot).forEach((item) =>
        item.removeAttribute('aria-current')
      );
    }
    _onPswpInitialZoomInEnd() {
      var _a;
      (_a = this.pswpUi) == null
        ? void 0
        : _a.classList.remove('pswp__ui--hidden');
    }
    _onPswpInitialZoomOut() {
      var _a;
      (_a = this.pswpUi) == null
        ? void 0
        : _a.classList.add('pswp__ui--hidden');
    }
    _onPswpParseVerticalMargin(item) {
      item.vGap.bottom =
        this.photoSwipeInstance.items.length <= 1 ||
        window.matchMedia(window.themeVariables.breakpoints.lapAndUp).matches
          ? 0
          : 60;
    }
  };
  var ProductImageZoom = class extends OpenableElement {
    connectedCallback() {
      super.connectedCallback();
      this.mediaElement = this.closest('.product__media');
      this.maxSpreadZoom = window.themeVariables.settings.mobileZoomFactor || 2;
      LibraryLoader.load('photoswipe');
    }
    disconnectedCallback() {
      var _a;
      super.disconnectedCallback();
      (_a = this.photoSwipeInstance) == null ? void 0 : _a.destroy();
    }
    async attributeChangedCallback(name, oldValue, newValue) {
      super.attributeChangedCallback(name, oldValue, newValue);
      switch (name) {
        case 'open':
          if (this.open) {
            await LibraryLoader.load('photoswipe');
            this._openPhotoSwipe();
          }
      }
    }
    async _openPhotoSwipe() {
      const items = await this._buildItems();
      this.photoSwipeInstance = new window.ThemePhotoSwipe(
        this,
        PhotoSwipeUi,
        items,
        {
          index: items.findIndex((item) => item.selected),
          maxSpreadZoom: this.maxSpreadZoom,
          loop: false,
          allowPanToNext: false,
          closeOnScroll: false,
          closeOnVerticalDrag: MediaFeatures.supportsHover(),
          showHideOpacity: true,
          arrowKeys: true,
          history: false,
          getThumbBoundsFn: () => {
            const thumbnail = this.mediaElement.querySelector(
                '.product__media-item.is-selected'
              ),
              pageYScroll =
                window.pageYOffset || document.documentElement.scrollTop,
              rect = thumbnail.getBoundingClientRect();
            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
          },
          getDoubleTapZoom: (isMouseClick, item) => {
            if (isMouseClick) {
              return item.w > item.h ? 1.6 : 1;
            } else {
              return item.initialZoomLevel < 0.7 ? 1 : 1.33;
            }
          },
        }
      );
      let lastWidth = null;
      this.photoSwipeInstance.updateSize = new Proxy(
        this.photoSwipeInstance.updateSize,
        {
          apply: (target, thisArg, argArray) => {
            if (lastWidth !== window.innerWidth) {
              target(arguments);
              lastWidth = window.innerWidth;
            }
          },
        }
      );
      this.photoSwipeInstance.listen('close', () => {
        this.open = false;
      });
      this.photoSwipeInstance.init();
    }
    async _buildItems() {
      const activeImages = Array.from(
          this.mediaElement.querySelectorAll(
            '.product__media-item[data-media-type="image"]:not(.is-filtered)'
          )
        ),
        product = await ProductLoader.load(this.getAttribute('product-handle'));
      return Promise.resolve(
        activeImages.map((item) => {
          const matchedMedia = product['media'].find(
              (media) =>
                media.id === parseInt(item.getAttribute('data-media-id'))
            ),
            supportedSizes = getSupportedSizes(
              matchedMedia,
              [
                200, 300, 400, 500, 600, 700, 800, 1e3, 1200, 1400, 1600, 1800,
                2e3, 2200, 2400, 2600, 2800, 3e3,
              ]
            ),
            desiredWidth = Math.min(
              supportedSizes[supportedSizes.length - 1],
              window.innerWidth
            );
          return {
            selected: item.classList.contains('is-selected'),
            src: getSizedMediaUrl(
              matchedMedia,
              `${Math.ceil(
                Math.min(
                  desiredWidth * window.devicePixelRatio * this.maxSpreadZoom,
                  3e3
                )
              )}x`
            ),
            msrc: item.firstElementChild.currentSrc,
            originalMedia: matchedMedia,
            w: desiredWidth,
            h: parseInt(desiredWidth / matchedMedia['aspect_ratio']),
          };
        })
      );
    }
  };
  window.customElements.define('product-image-zoom', ProductImageZoom);
